import React, { useEffect, useRef } from 'react';
import './Footer.scss';
import gsap from 'gsap';

const Footer = props => {
  const icons = useRef(null);
  const copyrightRef = useRef(null);

  useEffect(() => {
    if (!icons.current || !copyrightRef.current) return;

    const tl = gsap.timeline({
      onComplete: () => {
        icons.current?.classList.add('hover-icons');
      },
      onStart: () => {
        icons.current?.classList.remove('hover-icons');
      },
    });

    tl.fromTo(
      [...icons.current.children, copyrightRef.current],
      {
        opacity: 0,
        scale: 0,
      },
      {
        delay: 2,
        opacity: 1,
        scale: 1,
        ease: 'back',
        stagger: 0.1,
      }
    );
  }, [icons, copyrightRef]);

  return (
    <div className="home-footer">
      <div ref={icons} className="my-flex icons-container">
        <a
          className="icon-container"
          target="_blank"
          rel="noreferrer"
          href="https://www.linkedin.com/in/moidhasanbeig/"
        >
          <div className="connect-icon linkedin-icon link" />
        </a>
        <a
          className="icon-container"
          target="_blank"
          rel="noreferrer"
          href="https://github.com/MoidHasanBeig"
        >
          <div className="connect-icon github-icon link" />
        </a>
        <a
          className="icon-container"
          target="_blank"
          rel="noreferrer"
          href="mailto:moid.dev@outlook.com"
        >
          <div className="connect-icon mail-icon link" />
        </a>
      </div>
      <div ref={copyrightRef}>moid.dev&copy;{new Date().getFullYear()}</div>
    </div>
  );
};

export default Footer;
